import React, { useState } from 'react';
import {
  Progress,
  Card,
  Button,
  Space,
  Select,
  Typography,
  Divider,
  Statistic,
  Row
} from 'antd';
import { states, vals } from '../data/states';

const IdForm = ({ callback }) => {
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);

  const [location, setLocation] = useState('Alabama');
  const [foliageColor, setFoliageColor] = useState('green');
  const [flowerColor, setFlowerColor] = useState('purple');
  const [fruitColor, setFruitColor] = useState('red');

  const { Option } = Select;
  const { Title } = Typography;

  const nextClick = () => {
    if (step === questions.length - 1) {
      setLoading(true);
      fetchResults();
    } else {
      setStep(step + 1);
    }
  };

  const backClick = () => {
    setStep(step - 1);
  };

  const fetchResults = () => {
    // fetch(`https://trefle.io/api/v1/species/search?q=${query}&token=${TOKEN}`)
    //   .then((res) => {
    //     return res.json();
    //   })
    //   .then((json) => {
    //     callback(json.data);
    //     setLoading(false);
    //   })
    //   .catch((e) => {
    //     setError('An error has occurred, check the console for details.');
    //     setLoading(false);
    //     console.log(e);
    //   });
  };

  const determineLocation = (state) => {
    Object.keys(vals).map((key) => {
      if (vals[key].includes(state)) {
        return key;
      }
    });
  };

  const classes = {
    select: { width: 190, marginTop: '1rem' },
    card: { marginTop: '2rem', minHeight: '200px', paddingBottom: 0 }
  };

  const questions = [
    {
      q: 'Where was this plant located?',
      form: (
        <Select
          showSearch
          key='0'
          value={location}
          style={classes.select}
          onChange={setLocation}
        >
          {states.map((state, i) => (
            <Option value={state} key={i}>
              {state}
            </Option>
          ))}
        </Select>
      )
    },
    {
      q: 'What color is the foliage?',
      form: (
        <Select
          key='1'
          value={foliageColor}
          style={classes.select}
          onChange={setFoliageColor}
        >
          <Option value={'white'}>White</Option>,
          <Option value={'black'}>Black</Option>,
          <Option value={'green'}>Green</Option>,
          <Option value={'grey'}>Grey</Option>,
          <Option value={'red'}>Red</Option>,
          <Option value={'Pink'}>Pink</Option>,
          <Option value={'blue'}>Blue</Option>,
          <Option value={'purple'}>Purple</Option>,
          <Option value={'orange'}>Orange</Option>,
          <Option value={'brown'}>Brown</Option>,
          <Option value={'yellow'}>Yellow</Option>
        </Select>
      )
    },
    {
      q: 'What color are the flowers?',
      form: (
        <Select
          key='2'
          value={flowerColor}
          style={classes.select}
          onChange={setFlowerColor}
        >
          <Option value={'white'}>White</Option>,
          <Option value={'black'}>Black</Option>,
          <Option value={'green'}>Green</Option>,
          <Option value={'grey'}>Grey</Option>,
          <Option value={'red'}>Red</Option>,
          <Option value={'Pink'}>Pink</Option>,
          <Option value={'blue'}>Blue</Option>,
          <Option value={'purple'}>Purple</Option>,
          <Option value={'orange'}>Orange</Option>,
          <Option value={'brown'}>Brown</Option>,
          <Option value={'yellow'}>Yellow</Option>
          <Option value={'none'}>None</Option>
        </Select>
      )
    },
    {
      q: 'What color is the fruit?',
      form: (
        <Select
          key='3'
          value={fruitColor}
          style={classes.select}
          onChange={setFruitColor}
        >
          <Option value={'white'}>White</Option>,
          <Option value={'black'}>Black</Option>,
          <Option value={'green'}>Green</Option>,
          <Option value={'grey'}>Grey</Option>,
          <Option value={'red'}>Red</Option>,
          <Option value={'Pink'}>Pink</Option>,
          <Option value={'blue'}>Blue</Option>,
          <Option value={'purple'}>Purple</Option>,
          <Option value={'orange'}>Orange</Option>,
          <Option value={'brown'}>Brown</Option>,
          <Option value={'yellow'}>Yellow</Option>
          <Option value={'none'}>None</Option>
        </Select>
      )
    },
    {
      q: 'Please verify the plant information.',
      form: (
        <Space direction='vertical'>
          <Row>
            <Statistic title='Location 🌎' value={`${location}`} />
          </Row>
          <Row>
            <Statistic title='Foliage color 🌿' value={foliageColor} />
          </Row>
          <Row>
            <Statistic title='Flower color 🌺' value={flowerColor} />
          </Row>
          <Row>
            <Statistic title='Fruit color 🍊' value={fruitColor} />
          </Row>
        </Space>
      )
    }
  ];

  const ExtraButtons = () => {
    return (
      <Space
        style={{
          marginTop: '2rem'
        }}
      >
        <Button loading={loading} type='primary' onClick={nextClick}>
          {step === questions.length - 1 ? 'Submit' : 'Next'}
        </Button>
        {step > 0 && (
          <Button type='default' onClick={backClick} disabled={loading}>
            Back
          </Button>
        )}
      </Space>
    );
  };

  const title = questions[step].q;
  const percent = (step / (questions.length - 1)) * 100;

  return (
    <>
      <Progress percent={percent} style={{ marginTop: '1rem' }} />
      <Card style={classes.card}>
        <Title level={3}>{title}</Title>
        <Divider />
        {questions[step].form}
        <br />
        <ExtraButtons />
      </Card>
    </>
  );
};

export default IdForm;
